import { render, staticRenderFns } from "./demo-alcohol-promo-flow.vue?vue&type=template&id=d1b28eea&scoped=true&"
import script from "./demo-alcohol-promo-flow.vue?vue&type=script&lang=js&"
export * from "./demo-alcohol-promo-flow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b28eea",
  null
  
)

export default component.exports